'use strict';
import angular from 'angular';

import GoogleAdsExtensionHtmlUrl from './views/googleAdsExtension.list.html';
import _ from "lodash";

var app = angular.module('app.googleAdsExtension.component', []);

app.component('googleAdsExtension', {
    bindings: {
        selectedExtensions: '=',
        showActions: "=",
        clusterId: '=',
        isEdit:"=",
        campaignId:'='
    },
    templateUrl: GoogleAdsExtensionHtmlUrl,

    // The controller that handles our component logic
    controller: function($scope,$ioAlert, anchorSmoothScroll, $location, $timeout,ProductService, $stateParams, $rootScope) {
        var self = this;
        self.sitelinkExtensions = [];
        self.selectedSitelinkExensions = [];
        self.sitelinkExtensionsList = [];
        self.sitelinkExtensionSearch = "";
        self.calloutExtensionsList = [];
        self.calloutExtensionSearch = "";
        self.structuredSnippetExtensionList =[];
        self.structuredSnippetExtensionSearch = "";

        self.addSitelinkExtension =function() {
            self.selectedExtensions.sitelink.createNewExtensions.push({
                "sitelink_text": "",
                "description1": "",
                "description2": "",
                "final_url":""
            });
        }

        self.addCalloutExtension = function () {
            self.selectedExtensions.callout.createNewExtensions.push({
                "callout_text": ""
            });
        }
        self.addStructuredSnippetExtension = function (index) {

            self.selectedExtensions.structuredSnippet.createNewExtensions.push({
                "values": [{},{},{}],
                "header": ""
            });
        }

        self.addValue = function (index) {
            console.log(self.selectedExtensions.structuredSnippet.createNewExtensions,index);
            self.selectedExtensions.structuredSnippet.createNewExtensions[index].values.push({});
        }

        self.getSitelinkExtensionContents = function () {
            ProductService.getDevicesByContentKey({ clusterId: self.clusterId, contentKey: 'google_ads_sitelink_extension', order_id: $stateParams.orderId }).then(function (success) {
                if (success && success.lookupContents && success.lookupContents.length > 0) {
                    _.each(success.lookupContents, function (content) {
                        var sitelinks = {};
                        sitelinks.id = content.id;
                        sitelinks.sitelink_text = content.lookup_value;
                        sitelinks.description1 = content.description1;
                        sitelinks.description2 = content.description2;
                        sitelinks.final_url = content.final_url;
                        sitelinks.isChecked = false;
                        sitelinks.isEdit = false;
                        self.sitelinkExtensionsList.push(sitelinks);
                    });
                }
                processSitelinkExtensionData();
            }, function (error) { });
        }

        self.getStructuredSnippetExtensionContents = function () {
            ProductService.getDevicesByContentKey({ clusterId: self.clusterId, contentKey: 'google_ads_structured_snippet_extension' , order_id: $stateParams.orderId}).then(function (success) {
                if (success && success.lookupContents && success.lookupContents.length > 0) {
                    _.each(success.lookupContents, function (content) {
                        var structuredSnippet = {};
                        structuredSnippet.id = content.id;
                        structuredSnippet.values = content.values;
                        structuredSnippet.header = content.header;
                        structuredSnippet.isChecked = false;
                        structuredSnippet.isEdit = false;
                        self.structuredSnippetExtensionList.push(structuredSnippet);
                    });
                }
                processStructuredSnippetExtensionData();
            }, function (error) { });
        }

        self.getCalloutExtensionContents = function () {
            ProductService.getDevicesByContentKey({ clusterId: self.clusterId, contentKey: 'google_ads_callout_extension', order_id: $stateParams.orderId }).then(function (success) {
                if (success && success.lookupContents && success.lookupContents.length > 0) {
                    _.each(success.lookupContents, function (content) {
                        var callout = {};
                        callout.id = content.id;
                        callout.callout_text = content.lookup_value;
                        callout.isChecked = false;
                        callout.isEdit = false;
                        self.calloutExtensionsList.push(callout);
                    })
                }
                processCalloutExtensionData();
            }, function (error) { });
        }

        self.handleSelectSitelinkExtensions = function (sitelink) {
            if (!sitelink.isChecked) {
                sitelink.isChecked = false;
                sitelink.isEdit = false;
                var selIndex = self.selectedExtensions.sitelink.useExistingExtensions.indexOf(sitelink);
                if (selIndex >= 0) {
                    self.selectedExtensions.sitelink.useExistingExtensions.splice(selIndex, 1);
                } else {
                    if (self.selectedExtensions.sitelink.useExistingExtensions && self.selectedExtensions.sitelink.useExistingExtensions.length > 0) {
                        if (_.find(self.selectedExtensions.sitelink.useExistingExtensions, { id: sitelink.id })) {
                            var index = _.findIndex(self.selectedExtensions.sitelink.useExistingExtensions, { id: sitelink.id });
                            self.selectedExtensions.sitelink.useExistingExtensions.splice(index, 1);
                        }
                    }
                }
            } else {
                let sitelinkExtesnion = {};
                sitelinkExtesnion.isChecked = true;
                sitelinkExtesnion.isEdit = false;
                sitelinkExtesnion.id = sitelink.id;
                sitelinkExtesnion.sitelink_text = sitelink.sitelink_text;
                self.selectedExtensions.sitelink.useExistingExtensions.push(sitelinkExtesnion);
            }
        }


        self.handleSelectStructuredSnippetExtensions = function (structuredsnippet) {
            if (!structuredsnippet.isChecked) {
                structuredsnippet.isChecked = false;
                structuredsnippet.isEdit = false;
                var selIndex = self.selectedExtensions.structuredSnippet.useExistingExtensions.indexOf(structuredsnippet);
                if (selIndex >= 0) {
                    self.selectedExtensions.structuredSnippet.useExistingExtensions.splice(selIndex, 1);
                } else {
                    if (self.selectedExtensions.structuredSnippet.useExistingExtensions && self.selectedExtensions.structuredSnippet.useExistingExtensions.length > 0) {
                        if (_.find(self.selectedExtensions.structuredSnippet.useExistingExtensions, { id: structuredsnippet.id })) {
                            var index = _.findIndex(self.selectedExtensions.structuredSnippet.useExistingExtensions, { id: structuredsnippet.id });
                            self.selectedExtensions.structuredSnippet.useExistingExtensions.splice(index, 1);
                        }
                    }
                }
            } else {
                let structuredsnippetExtesnion = {};
                structuredsnippetExtesnion.isChecked = true;
                structuredsnippetExtesnion.isEdit = false;
                structuredsnippetExtesnion.id = structuredsnippet.id;
                structuredsnippetExtesnion.values = structuredsnippet.values;
                structuredsnippetExtesnion.header = structuredsnippet.header;
                self.selectedExtensions.structuredSnippet.useExistingExtensions.push(structuredsnippetExtesnion);
            }
        }

        self.handleSelectCalloutExtensions = function (callout) {
            if (!callout.isChecked) {
                callout.isChecked = false;
                callout.isEdit = false;
                var selIndex = self.selectedExtensions.callout.useExistingExtensions.indexOf(callout);
                if (selIndex >= 0) {
                    self.selectedExtensions.callout.useExistingExtensions.splice(selIndex, 1);
                } else {
                    if (self.selectedExtensions.callout.useExistingExtensions && self.selectedExtensions.callout.useExistingExtensions.length > 0) {
                        if (_.find(self.selectedExtensions.callout.useExistingExtensions, { id: callout.id })) {
                            var index = _.findIndex(self.selectedExtensions.callout.useExistingExtensions, { id: callout.id });
                            self.selectedExtensions.callout.useExistingExtensions.splice(index, 1);
                        }
                    }
                }
            } else {
                let calloutExtesnion = {};
                calloutExtesnion.isChecked = true;
                calloutExtesnion.isEdit = false;
                calloutExtesnion.id = callout.id;
                calloutExtesnion.callout_text = callout.callout_text;
                self.selectedExtensions.callout.useExistingExtensions.push(calloutExtesnion);
            }
        }

        self.removeSelectedExtensions = function (item, selectedExtensions, extensionList) {
            var selIndex = selectedExtensions.findIndex(el => el.id === item.id);
            if (selIndex >= 0) {
                selectedExtensions.splice(selIndex, 1);
            }
            var index = _.findIndex(extensionList, { id: item.id });
            if (index >= 0) {
                extensionList[index].isChecked = false;
            }
        }

        self.editExistingSitelink = function (sitelink) {
            self.removeSelectedExtensions(sitelink, self.selectedExtensions.sitelink.useExistingExtensions, self.sitelinkExtensionsList);
            _.find(self.sitelinkExtensionsList, { id: sitelink.id }).isEdit = true;
            self.selectedExtensions.sitelink.createNewExtensions.push({
                "id": sitelink.id,
                "sitelink_text": sitelink.sitelink_text,
                "description1": sitelink.description1,
                "description2": sitelink.description2,
                "final_url":sitelink.final_url
            });
        }

        self.editExistingStructuredSnippet = function (structuredSnippet) {
            self.removeSelectedExtensions(structuredSnippet, self.selectedExtensions.structuredSnippet.useExistingExtensions, self.structuredSnippetExtensionList);
            _.find(self.structuredSnippetExtensionList, {id: structuredSnippet.id}).isEdit = true;
            var valuesToEdit = [];
            for (let value of structuredSnippet.values) {
                valuesToEdit.push({value});
            }
            self.selectedExtensions.structuredSnippet.createNewExtensions.push({
                "id": structuredSnippet.id,
                "values": valuesToEdit,
                "header": structuredSnippet.header
            });
        }

        self.editExistingCallout = function (callout) {
            self.removeSelectedExtensions(callout, self.selectedExtensions.callout.useExistingExtensions, self.calloutExtensionsList);
            _.find(self.calloutExtensionsList, { id: callout.id }).isEdit = true;
            self.selectedExtensions.callout.createNewExtensions.push({
                "id": callout.id,
                "callout_text": callout.callout_text
            });
        }

        var processSitelinkExtensionData = function () {
            if (self.selectedExtensions.sitelink.useExistingExtensions) {
                _.each(self.selectedExtensions.sitelink.useExistingExtensions, function (selectedSitelinks) {
                    _.find(self.sitelinkExtensionsList, { id: selectedSitelinks.id }).isChecked = true;
                })
            }
        }

        var processCalloutExtensionData = function () {
            if (self.selectedExtensions.callout.useExistingExtensions) {
                _.each(self.selectedExtensions.callout.useExistingExtensions, function (selectedCallouts) {
                    _.find(self.calloutExtensionsList, { id: selectedCallouts.id }).isChecked = true;
                })
            }
        }

        var processStructuredSnippetExtensionData = function () {
            if (self.selectedExtensions.structuredSnippet.useExistingExtensions) {
                _.each(self.selectedExtensions.structuredSnippet.useExistingExtensions, function (selectedStructuredSnippets) {
                    _.find(self.structuredSnippetExtensionList, { id: selectedStructuredSnippets.id }).isChecked = true;
                })
            }
        }

        self.delSitelinkExtension = function(index) {
            if (self.selectedExtensions.sitelink.createNewExtensions[index].id) {
                _.find(self.sitelinkExtensionsList, { id: self.selectedExtensions.sitelink.createNewExtensions[index].id }).isEdit = false;
            }
            self.selectedExtensions.sitelink.createNewExtensions.splice(index, 1);
        };

        self.delStructuredSnippetExtension = function(extentionIndex) {
            if (self.selectedExtensions.structuredSnippet.createNewExtensions[extentionIndex].id) {
                _.find(self.structuredSnippetExtensionList, { id: self.selectedExtensions.structuredSnippet.createNewExtensions[extentionIndex].id }).isEdit = false;
            }
            self.selectedExtensions.structuredSnippet.createNewExtensions.splice(extentionIndex,1 );
        }

        self.delValue = function(index, extentionIndex) {
            self.selectedExtensions.structuredSnippet.createNewExtensions[extentionIndex].values.splice(index, 1);
        }

        self.delCalloutExtension = function(index) {
            if (self.selectedExtensions.callout.createNewExtensions[index].id) {
                _.find(self.calloutExtensionsList, { id: self.selectedExtensions.callout.createNewExtensions[index].id }).isEdit = false;
            }
            self.selectedExtensions.callout.createNewExtensions.splice(index, 1);
        };

        var initSitelink = function () {
            self.selectedExtensions.sitelink = {
                useExistingExtensions: [],
                createNewExtensions: [],
                advanced_option: false
            };
        }

        var initCallout = function () {
            self.selectedExtensions.callout = {
                useExistingExtensions: [],
                createNewExtensions: [],
                advanced_option: false
            };
        }

        var initStructuredSnippet = function () {
            self.selectedExtensions.structuredSnippet = {
                useExistingExtensions: [],
                createNewExtensions: [],
                advanced_option: false
            };
        }

        self.initComponent = function () {
            if (self.selectedExtensions && !_.isEmpty(self.selectedExtensions)) {
                self.selectedExtensions = JSON.parse(self.selectedExtensions);
                if (!('sitelink' in self.selectedExtensions)) {
                    initSitelink();
                }
                if (!('callout' in self.selectedExtensions)) {
                    initCallout();
                }
                if (!('structuredSnippet' in self.selectedExtensions)) {
                    initStructuredSnippet();
                }

            }
            else {
                self.selectedExtensions = {
                    sitelink:{
                        useExistingExtensions: [],
                        createNewExtensions: [],
                        advanced_option: false
                    },
                    callout:{
                        useExistingExtensions: [],
                        createNewExtensions: [],
                        advanced_option: false
                    },

                    structuredSnippet:{
                        useExistingExtensions: [],
                        createNewExtensions: [],
                        advanced_option: false
                    }
                };
            }
            self.getSitelinkExtensionContents();
            self.getCalloutExtensionContents();
            self.getStructuredSnippetExtensionContents();
        };

        self.initComponent();
    }
});